/*
 * @Author: Teemo Ding
 * @Date: 2021-08-31 10:04:33
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 13:08:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleEdit/index.tsx
 */
import { Button, Skeleton } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CommonHeader from '@/src/components/CommonHeader';
import { NEW } from '@/src/tools/constant';
import {
  DiscountType,
  EnumStatus,
  StatusChange,
} from '@/src/types/common/discount';
import { Form, message } from 'antd';
import { get } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { handleOnCheckTime } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/tools';
import { getParameter, onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { modal } from 'src/utils/Modal';

import { breadcrumbData } from './config';

import { RemindUnitProps } from '@/src/types/common';
import Attributes from './Attribute';
import BasicInformation from './BasicInformation';
import FlashSaleGroups from './FlashSaleGroups';
import Summary from './Summary';

import {
  archiveFlashSale,
  getFlashSaleDetail,
  initFlashSale,
  publishFlashSale,
  saveFlashSale,
  toDraftFlashSale,
} from '@/src/request/salesChannel/discounts/flashSale';

import NoPermission from '@/src/components/NoPermission';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { discountPermissions } from '../../Components/hooks/permissions';
import css from './css.module.less';

const formName = 'FlashSaleEdit';
interface IParams {
  uuid: string;
  discountUuid: string;
}

const defaultFlashSaleGroups = [
  {
    salesChannelProductList: [],
    flashSaleDiscount: {
      discountType: 'PercentageOff',
      percentageOff: '',
      reductionAmount: '',
      currencyCode: '',
    },
  },
];

const changeStatusList = {
  [EnumStatus.Draft]: [StatusChange.Archive, StatusChange.Publish],
  [EnumStatus.Active]: [StatusChange.Archive, StatusChange.ToDraft],
  [EnumStatus.Scheduled]: [StatusChange.Archive, StatusChange.ToDraft],
  [EnumStatus.Archived]: [StatusChange.Restore],
  [EnumStatus.Expired]: [StatusChange.Archive, StatusChange.ToDraft],
  undefined: [],
  null: [],
};
const FlashSaleEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;

  const history = useHistory();
  const params = useParams<IParams>();

  const { uuid, discountUuid } = params;
  const { canViewDetail, canEdit, canDelete } = discountPermissions(uuid);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const [activeTime, setActiveTime] = useState({
    beginDate: '',
    beginTime: '',
    endDate: '',
    endTime: '',
  });
  const defaultName = getParameter('defaultName');
  const [hasModified, setHasModified] = useState<boolean>(
    discountUuid == NEW ? true : false,
  );
  const [activeTimeError, setActiveTimeError] = React.useState(false);
  const [activeTimeText, setActiveTimeErrorText] = React.useState('');
  const [flashSaleFormData, setFlashSaleFormData] = useState<any>({});
  const [salesChannelName, setSalesChannelName] = useState('');
  const isDraftArchive =
    flashSaleFormData.status === EnumStatus.Draft ||
    flashSaleFormData.status === EnumStatus.Archived;
  const isActive =
    flashSaleFormData.status === EnumStatus.Active ||
    flashSaleFormData.status === EnumStatus.Scheduled ||
    flashSaleFormData.status === EnumStatus.Expired;
  // const [currency, setCurrency] = useState('');

  useEffect(() => {
    if (canViewDetail) {
      handleRequestDetail(discountUuid);
    }
  }, [discountUuid]);

  const handleRequestDetail = (_flashSaleUuid) => {
    if (!loading) {
      setLoading(true);
    }

    const request =
      _flashSaleUuid == NEW
        ? initFlashSale(uuid)
        : getFlashSaleDetail(_flashSaleUuid);

    request.then((detail) => {
      const {
        activeBeginDate,
        activeBeginTime,
        activeEndDate,
        activeEndTime,
        flashSaleGroups,
        salesChannelName,
      } = detail;
      setSalesChannelName(salesChannelName);
      const flashSaleGroupsCover = flashSaleGroups.map((group) => {
        const { discountType, percentageOff, reductionAmount, currencyCode } =
          group;
        return {
          ...group,
          flashSaleDiscount: {
            discountType: discountType || DiscountType.PercentageOff,
            percentageOff,
            reductionAmount,
            currencyCode,
          },
        };
      });
      setActiveTime({
        beginDate: activeBeginDate,
        beginTime: activeBeginTime,
        endDate: activeEndDate,
        endTime: activeEndTime,
      });
      setFlashSaleFormData({
        ...detail,
        flashSaleGroups: flashSaleGroupsCover,
        name: _flashSaleUuid == NEW && defaultName ? defaultName : detail.name,
      });
      setLoading(false);
      console.log(defaultName);
    });
  };

  const handleActiveTime = (value) => {
    setActiveTime(value);
    setHasModified(true);
  };

  const handleOnSubmitDraft = () => {
    form.validateFields(['name']).then(() => {
      const value = form.getFieldsValue();
      onFinish(value);
    });
  };

  const handleOnSubmitPublish = () => {
    const { valid: isTimeValid, message } = handleOnCheckTime(activeTime || {});
    if (isTimeValid) {
      form.validateFields().then((res) => {
        onFinish(res);
      });
    } else {
      setActiveTimeError(true);
      setActiveTimeErrorText(message);
      timeoutScroll('DirectDiscountBasicInfo');
    }
  };

  const handleOnToPublish = () => {
    const { valid: isTimeValid, message } = handleOnCheckTime(activeTime || {});
    if (isTimeValid) {
      return form
        .validateFields()
        .then(() => {
          if (hasModified) {
            modal.info({
              title: getI18n('general.saveChanges'),
              content: getI18n('general.publishTip'),
              //onCancel,
              onOkText: getI18n('general.saveChanges'),
              onOk: () => handleOnSubmitPublish(),
              // onCancelText,
            });
          } else {
            handleChangeStatus(StatusChange.Publish);
          }
        })
        .catch((e) => {
          modal.info({
            title: getI18n('general.unabletoPublish'),
            content: getI18n('general.fixAllErr'),
            //onCancel,
            onOkText: 'Go to edit',
            onOk: () => onFinishFailed(formName, e),
            // onCancelText,
          });
        });
    } else {
      modal.info({
        title: getI18n('general.unabletoPublish'),
        content: message || 'Please correct start and end time',
        //onCancel,
        onOkText: 'Go to edit',
        onOk: () => {
          setActiveTimeError(true);
          setActiveTimeErrorText(message);
          timeoutScroll('DirectDiscountBasicInfo');
        },
      });
    }
  };

  const handleOnSubmit = () => {
    if (isDraftArchive) {
      return handleOnSubmitDraft();
    }
    if (isActive) {
      return handleOnSubmitPublish();
    }
  };

  const onFinish = (values) => {
    console.log(values);
    values.flashSaleGroups = values.flashSaleGroups.map((group) => ({
      ...group,
      ...group.flashSaleDiscount,
    }));
    values.salesChannelUuid = uuid;
    values.uuid = discountUuid == NEW ? '' : discountUuid;
    values.status = get(flashSaleFormData, 'status', EnumStatus.Draft);
    values.activeBeginDate = activeTime.beginDate;
    values.activeBeginTime = activeTime.beginTime;
    values.activeEndDate = activeTime.endDate;
    values.activeEndTime = activeTime.endTime;
    values.currency = get(flashSaleFormData, 'currency', '');
    saveFlashSale(values).then((data) => {
      message.success('Save success');
      setHasModified(false);
      setShowModal(false);
      setFlashSaleFormData({
        ...flashSaleFormData,
        canPublish: data.canPublish,
        status: data.status,
      });
      if (discountUuid == NEW && data.uuid) {
        history.replace(
          `/salesChannel/discounts/flashSale/editor/${uuid}/${data.uuid}`,
        );
      }
    });
  };

  const onValuesChange = () => {
    setHasModified(true);
  };

  const onGoBackClick = () => {
    history.push(`/salesChannel/discounts/flashSale/list/${uuid}`);
  };

  const statusChangeModal = ({ type, unSave }) => {
    const notAblePublishText = (
      <div>
        <div className={css.errorPublish}>
          {unSave
            ? `Please save change before ${type.toLocaleLowerCase()} this discount`
            : 'Archiving will deactivate this discount. You may find the archived discount in the archive section and restore it at any time.'}
        </div>{' '}
        <ModalFooter
          onCancel={() => setShowModal(false)}
          okText={unSave ? 'Save Changes' : 'Archive'}
          onOk={() => (unSave ? handleOnSubmit() : handleChangeStatus(type))}
        />
      </div>
    );
    setModalContent(notAblePublishText);
    setModalTitle(unSave ? 'Save Changes' : 'Archive Discount');
    setShowModal(true);
  };

  const handleChangeStatus = (type) => {
    if (hasModified) {
      statusChangeModal({ type, unSave: hasModified });
    } else {
      const changeStatusRequestList = {
        [StatusChange.Publish]: publishFlashSale,
        [StatusChange.ToDraft]: toDraftFlashSale,
        [StatusChange.Archive]: archiveFlashSale,
      };
      changeStatusRequestList[type]([discountUuid]).then((data) => {
        setShowModal(false);
        handleRequestDetail(discountUuid);
      });
    }
  };

  return canViewDetail ? (
    <div className={css.container}>
      <Skeleton loading={loading} active>
        <Form
          name={formName}
          form={form}
          initialValues={{
            name: get(flashSaleFormData, 'name', ''),
            flashSaleGroups: get(
              flashSaleFormData,
              'flashSaleGroups',
              defaultFlashSaleGroups,
            ),
            status: flashSaleFormData.status || EnumStatus.Draft,
            numOfRemindUnits: flashSaleFormData?.numOfRemindUnits || '',
            remindUnit: flashSaleFormData?.remindUnit || RemindUnitProps.Days,
            attributes: get(flashSaleFormData, 'attributes', []),
          }}
          onValuesChange={onValuesChange}
          className={css.editForm}>
          <CommonHeader
            breadcrumbData={breadcrumbData(
              uuid,
              salesChannelName,
              discountUuid,
              { getI18n },
            )}
            onSaveDisable={!hasModified || !canEdit}
            onSubmit={() => handleOnSubmit()}
            onDiscard={onGoBackClick}
            onGoBackClick={onGoBackClick}
            extendButton={
              discountUuid !== NEW ? (
                <Fragment>
                  {changeStatusList[flashSaleFormData.status].includes(
                    StatusChange.Archive,
                  ) && (
                    <Button
                      className={css.extendButton}
                      type='danger'
                      disabled={!canDelete}
                      onClick={() =>
                        statusChangeModal({
                          type: StatusChange.Archive,
                          unSave: hasModified,
                        })
                      }
                      ghost>
                      {getI18n('general.archive')}
                    </Button>
                  )}
                  {changeStatusList[flashSaleFormData.status].includes(
                    StatusChange.Publish,
                  ) && (
                    <Button
                      type='primary'
                      disabled={!canEdit}
                      className={css.extendButton}
                      onClick={() => handleOnToPublish()}
                      ghost>
                      {getI18n('general.publish')}
                    </Button>
                  )}
                  {changeStatusList[flashSaleFormData.status].includes(
                    StatusChange.ToDraft,
                  ) && (
                    <Button
                      type='primary'
                      disabled={!canEdit}
                      className={css.extendButton}
                      onClick={() => handleChangeStatus(StatusChange.ToDraft)}
                      ghost>
                      {getI18n('general.switchToDraft')}
                    </Button>
                  )}
                  {changeStatusList[flashSaleFormData.status].includes(
                    StatusChange.Restore,
                  ) && (
                    <Button
                      className={css.extendButton}
                      type='danger'
                      disabled={!canEdit}
                      onClick={() => handleChangeStatus(StatusChange.ToDraft)}
                      ghost>
                      {getI18n('general.restore')}
                    </Button>
                  )}
                </Fragment>
              ) : null
            }
          />
          <div className={css.flashSaleContain}>
            <Summary
              activeTime={activeTime}
              status={get(flashSaleFormData, 'status', '')}
            />
            <BasicInformation
              activeTime={activeTime}
              setActiveTime={handleActiveTime}
              activeTimeError={activeTimeError}
              activeTimeText={activeTimeText}
              setActiveTimeError={setActiveTimeError}
              existedTimeRange={get(flashSaleFormData, 'existedTimeRange', [])}
              disableEdit={!canDelete}
            />
            <FlashSaleGroups
              currency={get(flashSaleFormData, 'currency')}
              form={form}
              disableEdit={!canDelete}
            />
            <Attributes disableEdit={!canDelete} />
          </div>
        </Form>
      </Skeleton>
    </div>
  ) : (
    <NoPermission />
  );
};
export default ModalHoc(FlashSaleEdit);
